import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { useMultiStyleConfig as a, chakra as e, Skeleton as o } from "@chakra-ui/react";
const l = (d) => {
  const t = a("SavedListItem");
  return /* @__PURE__ */ i(e.div, { __css: t.root, height: 86, ...d, children: [
    /* @__PURE__ */ r(
      o,
      {
        borderRadius: "radius-100",
        boxSize: 68,
        endColor: "primary.100",
        startColor: "primary.50"
      }
    ),
    /* @__PURE__ */ i(e.div, { __css: { flex: 1, ...t.content }, children: [
      /* @__PURE__ */ r(
        o,
        {
          width: "100%",
          height: "12px",
          overflow: "hidden",
          marginTop: 2,
          borderRadius: "radius-50",
          endColor: "primary.100",
          startColor: "primary.50"
        }
      ),
      /* @__PURE__ */ r(
        o,
        {
          overflow: "hidden",
          borderRadius: "radius-50",
          endColor: "primary.100",
          marginTop: 4,
          marginBottom: 2,
          maxWidth: "132px",
          height: "8px",
          startColor: "primary.50"
        }
      ),
      /* @__PURE__ */ i(e.div, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
        /* @__PURE__ */ r(
          o,
          {
            flex: "1",
            overflow: "hidden",
            borderRadius: "radius-50",
            endColor: "primary.100",
            marginBottom: 2,
            maxWidth: "40px",
            height: "8px",
            startColor: "primary.50"
          }
        ),
        /* @__PURE__ */ r(
          o,
          {
            flex: "1",
            overflow: "hidden",
            borderRadius: "radius-50",
            endColor: "primary.100",
            marginBottom: 2,
            maxWidth: "40px",
            height: "8px",
            startColor: "primary.50"
          }
        )
      ] })
    ] })
  ] });
};
export {
  l as SavedListItemSkeleton
};
//# sourceMappingURL=SavedListItemSkeleton.es.js.map
